import { useChannelContext } from '../../../context/ChannelContext';
function createEventHandler(fn, message) {
    return function (event) {
        if (typeof fn !== 'function' || !(message === null || message === void 0 ? void 0 : message.mentioned_users)) {
            return;
        }
        fn(event, message.mentioned_users);
    };
}
export var useMentionsHandler = function (message, customMentionHandler) {
    var _a = useChannelContext(), channelOnMentionsClick = _a.onMentionsClick, channelOnMentionsHover = _a.onMentionsHover;
    var onMentionsClick = (customMentionHandler === null || customMentionHandler === void 0 ? void 0 : customMentionHandler.onMentionsClick) || channelOnMentionsClick || (function () { return null; });
    var onMentionsHover = (customMentionHandler === null || customMentionHandler === void 0 ? void 0 : customMentionHandler.onMentionsHover) || channelOnMentionsHover || (function () { return null; });
    return {
        onMentionsClick: createEventHandler(onMentionsClick, message),
        onMentionsHover: createEventHandler(onMentionsHover, message),
    };
};
export var useMentionsUIHandler = function (message, eventHandlers) {
    var _a = useChannelContext(), onMentionsClick = _a.onMentionsClick, onMentionsHover = _a.onMentionsHover;
    return {
        onMentionsClick: (eventHandlers === null || eventHandlers === void 0 ? void 0 : eventHandlers.onMentionsClick) || createEventHandler(onMentionsClick, message),
        onMentionsHover: (eventHandlers === null || eventHandlers === void 0 ? void 0 : eventHandlers.onMentionsHover) || createEventHandler(onMentionsHover, message),
    };
};
